import { render } from "./AppLogo.vue?vue&type=template&id=d0837294&scoped=true"
const script = {}

import "./AppLogo.vue?vue&type=style&index=0&id=d0837294&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0837294"]])

export default __exports__